/* Dialog components */
export * from './privacy-policy-dialog/privacy-policy-dialog.service';
export * from './terms-and-conditions-dialog/terms-and-conditions-dialog.service';
export * from './terms-and-privacy-policy-dialog.module';
